import request from '@/axios'

// 统计充电次数和总金额（当日/当月/上月）
export function getCountAndAmount(data={}) {
    return request({
        url: '/payment/statistics/countAndAmount',
        method: 'post',
        params: data
    })
}

// 查询近N天的每日统计数据（折线柱状图）
export function getDailyData(data={}) {
    return request({
        url: '/payment/statistics/dailyData',
        method: 'post',
        params: data
    })
}

// 收益排行榜（展示当月，每个设备的充电次数和收益金额）
export function getDeviceRanking(data={}) {
    return request({
        url: '/payment/statistics/deviceRanking',
        method: 'post',
        params: data
    })
}

